import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TicketCreationRequestControlService {
  private activeContactIds: string[] = [];

  checkTicketRequest(masterId: string): boolean {
    return this.activeContactIds.some((id) => id === masterId);
  }

  saveTicketRequest(masterId: string) {
    this.activeContactIds.push(masterId);
  }

  clearUpLastTicketCreationRequest() {
    if (this.activeContactIds.length > 50) {
      this.activeContactIds.shift();
    }
  }

  removeTicketRequest(masterId: string) {
    this.activeContactIds = this.activeContactIds.filter(
      (id) => id !== masterId,
    );
  }
}
